import React from "react";
import { connect } from "react-redux";

import Tooltip from "@/src/components/common/Elements/Tooltip/Tooltip";

@connect( store => {
    return { 
        loggedUser: store.loggedUser,
        conversations: store.conversations
    };
})

class Info extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { conversations,  isAdmin, dispatch } = this.props;

        if( conversations.selected.id ) {
            
            return (
                <div>
                    <a  class={`conversationInfoAction ${ isAdmin ? "active" : "" }`}   data-tooltip-id={`conversation-details`} 
                        onClick={e => { e.preventDefault(); 
                            dispatch({ type: "SET_CONVERSATIONS_TAB_SELECTED", selected: { id: "details", label: "Details" } })
                            dispatch({ type: "SET_CONVERSATIONS_SHOW_INFO_MODAL", showInfoModal: true });
                        }
                    } >
                        <i class="material-icons-outlined">info</i>
                    </a>
                    <Tooltip id={`conversation-details`} place="bottom" effect="solid">View Details</Tooltip>
                </div>
            );
        }

        return null;
    }
}

export default Info;